const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxMjYwLCJjb25ncmVzc0lkIjoxMzI0LCJkYXRlIjoiMjAyMi0wMy0xMFQwODo0MzoyOC42OTBaIiwiaWF0IjoxNjQ2OTAxODA4fQ.pyAqT6nlCU9_Gs-xsLmxqzpSDHxeBhBN1mNAGm0ZNP0';
const PLANNER_API_URL = 'https://ueg2022.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo3ODMsImNvbmdyZXNzSWQiOjEyNDUsImRhdGUiOiIyMDIxLTA1LTA1VDA5OjU1OjAwLjgyMFoiLCJpYXQiOjE2MjAyMDg1MDB9.enO0yJ7VLM-iHVyLOlyxbTFOc1GjXGcPk2nz9FEe6ao';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1324;
const SUBMISSION_API_URL = 'https://ueg2022.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}
